module.exports = __webpack_public_path__ + "img/messages.047b312d.svg";